module.exports = __webpack_public_path__ + "img/collection-profile.c1478206.jpg";